<template>
  <b-alert show variant="danger" class="bloqueo">Ha ocurrido un error, intente nuevamente y caso de persistir comuníquese con soporte técnico</b-alert>
</template>

<script>
export default {
    name:'WarningMessage',

}
</script>
<style>
.bloqueo{
    display: block !important;
}
</style>
